import {
  AppBar,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import PartialMediaAlert from '@/features/media/components/PartialMediaAlert'
import ExtendedNavContainer from './FullWidthNav'
import HeaderLogo from './HeaderLogo'
import HeaderMessage from './HeaderMessage'

export default function Header() {
  const title = useMediaQuery(useTheme().breakpoints.down('sm'))
    ? 'EMC'
    : 'Electronic Media Center'

  const headingTextStyle = {
    fontSize: '24px',
    lineHeight: '34px',
    letterSpacing: 0,
    fontWeight: '700',
    color: '#000',
  }

  return (
    <AppBar position="sticky" elevation={0} sx={{ backgroundColor: '#fff' }}>
      <Container maxWidth="xl">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Stack direction="row" spacing={2} alignItems="center" paddingY={2}>
            <HeaderLogo />
            <Typography sx={headingTextStyle}>{title}</Typography>
          </Stack>
          <PartialMediaAlert />
        </Stack>
      </Container>
      <HeaderMessage />
      <ExtendedNavContainer />
    </AppBar>
  )
}
